import { CanDeactivateFn } from '@angular/router';
import { NotificationsComponent } from '@pages/notifications/notifications.component';

export const notificationsDeactivateGuard: CanDeactivateFn<
  NotificationsComponent
> = (component) => component.markNotificationsAsReadOnExit();
